import { WrapperGS, WrapperValued } from '../core/WrapperGS';

export class TextAreaGS extends WrapperGS<HTMLTextAreaElement> implements WrapperValued
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === 'textarea';
    }

    constructor(el: HTMLTextAreaElement | string) {
        super(el);
    }

    public get value() { return this.el.value; }
    public set value(value: string) { this.el.value = value; }
}

WrapperGS.ExtendComponentsByHTMLElement(TextAreaGS);
